<template>
  <button class="font-bold py-2 px-4 rounded flex items-center" @click="clicked">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "Button",
  methods: {
    clicked: function(event) {
      this.$emit("click", this.page, event);
    },
  },
};
</script>

<style scoped></style>
